var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2AA3E",
    d: "M21.876 19.25L11.793 1.833c-.177-.265-.474-.424-.793-.424-.319 0-.616.16-.793.424L.124 19.25c-.164.283-.164.633 0 .916.163.284.465.459.793.459h20.166c.328 0 .63-.175.793-.459.164-.283.164-.633 0-.916zm-9.77-11.458l-.434 6.05h-1.344l-.409-6.05h2.186zM11 17.875c-.743 0-1.345-.602-1.345-1.345 0-.742.602-1.345 1.345-1.345s1.345.603 1.345 1.345c0 .743-.602 1.345-1.345 1.345z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLarge);
export default __webpack_public_path__ + "static/media/warning-large.69bb5dd4ae5933b0271ebcda7d3aaa75.svg";
export { ForwardRef as ReactComponent };